import router from '@/router/index.js';
export const purchaseProjectStatus = {
  methods: {
    defaultBtnText (status) {
      if ([10, 91].includes(status)) {
        return '编辑';
      } else if ([49, 51].includes(status)) {
        return '重新申请';
      } else if (status === 32) {
        return '确认公告';
      } else if (status === 41) {
        return '支付公告费';
      }
      // else if (status === 50) {
      //   return '报名审核';
      // }
      else if (status === 81) {
        return '创建合同';
      } else if (status === 88) {
        return '上传公示照片';
      } else {
        return '';
      }
    },
    defaultBtnAction (item) {
      if ([10, 91].includes(item.status)) {
        window.open(window.location.origin + '/#/publish-purchase/publisher-info?id=' + item.id);
      } else if ([49, 51].includes(item.status)) {
        // window.open(window.location.origin + '/#/publish-purchase/publisher-info?oldId=' + item.id);
        this.$router.push('/publish-purchase/publisher-info?oldId=' + item.id);
      } else if (item.status === 32) {
        router.push('/person-center/purchase-business/purchase-project/confirm-announcement?id=' + item.id);
      } else if (item.status === 41) {
        this.currentProjectId = item.id;
        this.showPayment = true;
      }
      // else if (item.status === 50) {
      //   router.push('/person-center/purchase-business/purchase-project/audit-apply/list?id=' + item.id);
      // }
      else if (item.status === 81) {
        router.push('/person-center/purchase-business/purchase-project/create-contract?id=' + item.id + '&projectType=' + item.projectType);
      } else if (item.status === 88) {
        this.$router.push('/person-center/purchase-business/purchase-project/upload-public-image?id=' + item.id);
      }
    }
  }
};
